export interface NewVsOldCountySeed {
  county: string;
  town: string;
}

export const NEW_VS_OLD_COUNTY_SEEDS: NewVsOldCountySeed[] = [
  { county: 'antrim', town: 'belfast' },
  { county: 'armagh', town: 'armagh' },
  { county: 'carlow', town: 'carlow' },
  { county: 'cavan', town: 'cavan' },
  { county: 'clare', town: 'ennis' },
  { county: 'cork', town: 'cork-city' },
  { county: 'derry', town: 'derry' },
  { county: 'donegal', town: 'letterkenny' },
  { county: 'down', town: 'newry' },
  { county: 'dublin', town: 'dublin' },
  { county: 'fermanagh', town: 'enniskillen' },
  { county: 'galway', town: 'galway-city' },
  { county: 'kerry', town: 'tralee' },
  { county: 'kildare', town: 'naas' },
  { county: 'kilkenny', town: 'kilkenny' },
  { county: 'laoise', town: 'portlaoise' },
  { county: 'leitrim', town: 'carrick-on-shannon' },
  { county: 'limerick', town: 'limerick-city' },
  { county: 'longford', town: 'longford' },
  { county: 'louth', town: 'drogheda' },
  { county: 'mayo', town: 'castlebar' },
  { county: 'meath', town: 'navan' },
  { county: 'monaghan', town: 'monaghan' },
  { county: 'offaly', town: 'tullamore' },
  { county: 'roscommon', town: 'roscommon' },
  { county: 'sligo', town: 'sligo' },
  { county: 'tipperary', town: 'clonmel' },
  { county: 'tyrone', town: 'omagh' },
  { county: 'waterford', town: 'waterford-city' },
  { county: 'westmeath', town: 'athlone' },
  { county: 'wexford', town: 'wexford' },
  { county: 'wicklow', town: 'bray' },
];

export const toCountyComparisonSlug = (county: string) =>
  `new-build-vs-second-hand-homes-${String(county || '').trim().toLowerCase()}`;

export const toTownComparisonSlug = (town: string) =>
  `buying-a-new-house-vs-period-property-in-${String(town || '').trim().toLowerCase()}`;

export const toTitleCase = (value = '') =>
  String(value || '')
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
